export default __webpack_public_path__ + "421488a2d70a5bc45af810acc250c564.png";